import { useMemo } from 'react';

import { LegacyProvider as CommentsContextProvider } from '@hotjar/comments/context/global-context';

import { event, tagRecording } from '@hotjar/webapp/tracking/tools/hotjar';
import { useAuthorization } from '@hotjar/webapp/domains/authorization';

interface CommentsContextProps {
  children: React.ReactNode;
}

export const CommentsContext = ({ children }: CommentsContextProps): JSX.Element => {
  const commentsContextObject = useMemo(
    () => ({
      event,
      tagRecording,
      useAuthorization,
    }),
    [],
  );

  return (
    <CommentsContextProvider value={commentsContextObject}>{children}</CommentsContextProvider>
  );
};
